import styled from "styled-components";

export default styled.div`
.enterprise {
  margin-left:20px;
}

.imagePreview{
  width: 100%;
  max-width: 150px;
  min-width: 75px;  
}
`